export enum CoverageAndAccessibility {
	GARAGE = 'GARAGE',
	PARKING = 'PARKING',
	OPEN_AIR = 'OPEN_AIR',
	MULTIFLOOR = 'MULTIFLOOR',
	WITH_SHELTER = 'WITH_SHELTER',
	BASEMENT = 'BASEMENT',
}
